// src/store/modules/landing-page.js
import { GET_PARTICIPANTS, UPDATE_PARTICIPANT, UPDATE_STATUS_PARTICIPANT } from '@/store/action-types';
import { SET_PARTICIPANTS, SET_PARTICIPANT } from '@/store/mutation-types';
import { GET_PARTICIPANT } from '@/store/getters-types';
import participantModel from '@/models/participants/participants';

export default {
  namespaced: true,
  actions: {
    async [GET_PARTICIPANTS]({ commit }, { eventId }) {
      commit(SET_PARTICIPANTS, await participantModel.getAll(eventId));
    },
    async [UPDATE_PARTICIPANT]({ commit }, { participant }) {
      let participantOut = await participantModel.update(participant.id, participant)
      commit(SET_PARTICIPANT, { participant: participantOut })
    },
    async [UPDATE_STATUS_PARTICIPANT]({ commit }, { participantId, url }) {
      await participantModel.updateStatus(url)
      let participantOut = await participantModel.get(participantId);
      commit(SET_PARTICIPANT, { participant: participantOut })
    },
  },
  mutations: {
    [SET_PARTICIPANTS](state, event) {
      let tempMap = new Map()
      event.forEach(element => {
        tempMap.set(element.id, element);
      });
      state.participantlist = tempMap
    },
    [SET_PARTICIPANT](state, { participant }) {
      state.participantlist.set(participant.id, participant)
    },
  },
  getters: {
    // ...
    [GET_PARTICIPANT]: (state) => (participantId) => {
      let out = state.participantlist.get(participantId);
      return out;
    },
  },
  // We initialize the state with
  // an empty LandingPage object.
  state: {
    participantlist: new Map(),
    config: {},
  },
};